export default function CBasicTypes() {
  return <h2>C Basic Types</h2>;
}
